import appGlobalScript from '/tmp/scratch/ticom-feature-components_m3dpV/src/global/index.ts';
export const globalScripts = appGlobalScript;
